import React from 'react'
import * as Displays from 'support/displays'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import { Translation } from '@morningtrain/react-translations'
import {Env} from "@morningtrain/helpers";

export default function SalaryExpenditure () {
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');

  return (
    <>
      <div className='h-8' />

      <SmartviewHeader>
        <Translation name='salary_expenses' />
      </SmartviewHeader>
      <SmartviewTextGroup highlight>
        <Displays.Currency name='fixed_salary_costs' decimals={0} />
        <SmartviewText label={<><span><Translation name='total_salary_expenses' /></span><Displays.Currency name='cost' decimals={0} /></>} textSize='text-xs'>
          <div className='flex justify-between'>
            <span><Translation name='remaining_salary_expenses' /></span>
            <Displays.Currency name='available_cost' decimals={0} />
          </div>
          <div className='flex justify-between'>
            <span><Translation name='wage_ratio' /></span>
            <Displays.Percentage name='wage_ratio' decimals={2} />
          </div>
        </SmartviewText>
        { hasKitchen && hasWaiter ?
          <SmartviewText
              label={(
                <>
                  <span><Translation name='generic.kitchen' /></span>
                  <Displays.Currency name='kitchen_cost' decimals={0} />
                </>
                    )} textSize='text-xs'
              >
              <div className='flex justify-between'>
                <span><Translation name='ratio_of_total_expenses' /></span>
                <Displays.Percentage name='cost_distribution_kitchen' decimals={2} />
              </div>
            </SmartviewText> : false}
        { hasKitchen && hasWaiter ?
         <SmartviewText
          label={(
            <>
              <span><Translation name='generic.waiter' /></span>
              <Displays.Currency name='waiter_cost' decimals={0} />
            </>
                )} textSize='text-xs'
        >
          <div className='flex justify-between'>
            <span><Translation name='ratio_of_total_expenses' /></span>
            <Displays.Percentage name='cost_distribution_waiter' decimals={2} />
          </div>
        </SmartviewText> : false }
      </SmartviewTextGroup>
    </>
  )
}
